<template>
  <div>
    <div class="footer d-center">
      <div class="footer-main fs-sm">
        <div class="d-flex" v-for="item in navData" :key="item.id">
          <div class="three">···</div>
          <div class="column">
            <div class="column-title">{{ item.name }}</div>
            <li
              v-for="each in item.child"
              :key="each.id"
              @click.stop="changePageLi(each.href, item, each)"
            >
              <a href="">{{ each.title }}</a>
            </li>
          </div>
        </div>

        <div class="three">···</div>
      </div>
    </div>
    <div class="footer-copyright d-center">
      <div class="d-flex copyright">
        <img class="footer-img" src="../../assets/img/image 6.png" />
        <div class="footer-content fs-md">
          <div>
            COPYRIGHT©2022 &nbsp;&nbsp;&nbsp;浙大城市学院·体育美育教学部
          </div>
          <div style="margin-top: 8px">
            地址: 浙江省杭州市拱墅区湖州街51号
            &nbsp;&nbsp;&nbsp;邮箱:&nbsp;tmb@zucc.edu.cn
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import navigationData from '../../assets/js/navData'
export default {
  data() {
    return {
      navData: [],
    }
  },
  created() {
    this.navData = navigationData
  },
  methods: {
    changePageLi(path, item, each) {
      this.$store.commit('setCurrNavNum', each.id)
      let mypath = ''
      if (each.href == '/video') {
        mypath = '/teaching'
      } else {
        mypath = each.href
      }
      this.$router.push({
        path,
        query: {
          one: item.name,
          two: each.title,
          three: '',
          path: mypath,
          oneInfo: { name: item.name, path: item.href },
          twoInfo: { name: each.title, path: each.href },
          threeInfo: { name: '', path: '' },
          keepalive: each.id,
          keepchild: 0,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/main.scss';
.footer {
  width: 100%;
  min-width: 1100px;
  height: 200px;
  background-color: $mintGreen;
  padding-top: 32px;
}
.three {
  margin-top: 8px;
  color: $darkGrenn;
  margin-left: 4px;
  margin-right: 16px;
}
.footer-main {
  width: 1100px;
  display: flex;
  justify-content: space-evenly;
}
.column {
  padding: 8px;
  color: $darkGrenn;
  li {
    list-style: none;
    color: $titleFont;
    margin-top: 4px;
  }
  a {
    text-decoration: none;
    color: $titleFont;
  }
  .column-title {
    margin-bottom: 8px;
    font-weight: 600;
  }
}
.footer-copyright {
  width: 100%;
  min-width: 1100px;
  height: 116px;
  background-color: $footer;
  .footer-img {
    width: 56px;
    height: 68px;
  }
}
.copyright {
  display: flex;
  align-items: center;
}
.footer-content {
  color: $white;
  line-height: 22px;
  margin-left: 48px;
}
</style>
